import React from "react";
import "./about.css";
import PHOTO from "../../assets/photo.JPEG";
import { FaAward } from "react-icons/fa";

function About() {
  return (
    <section id="about">
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={PHOTO} alt="Emre Durmus" />
          </div>
        </div>

        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>Experience</h5>
              <small>"01.05.2023" - Ongoing</small>
            </article>
          </div>

          <p>
            I am developing software using Java Spring Boot, JavaScript, C#, and
            Vaadin technologies. My responsibilities include designing and
            implementing various features of the system, as well as managing
            deployment processes to ensure smooth and efficient delivery to the
            production environment.
          </p>
        </div>
      </div>
    </section>
  );
}

export default About;
